import React from 'react';
import { motion } from 'framer-motion';

const FloatingElement = ({ 
  children, 
  delay = 0, 
  duration = 6,
  yOffset = 15,
  className = "" 
}) => {
  return (
    <motion.div
      className={className}
      animate={{
        y: [-yOffset/2, yOffset/2, -yOffset/2],
      }}
      transition={{
        duration: duration,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut",
        delay: delay
      }}
    >
      {children}
    </motion.div>
  );
};

export default FloatingElement;